export const SET_NEW_ORG_DATA = 'SET_NEW_ORG_DATA';
export const SET_NEW_ORG_FLOW_STEP = 'SET_NEW_ORG_FLOW_STEP';
export const SET_NEW_ORG_FLOW_TYPE = 'SET_NEW_ORG_FLOW_TYPE';
export const CANCEL_NEW_ORG_FLOW = 'CANCEL_NEW_ORG_FLOW'